import { CurrencyPipe, DatePipe } from '@angular/common';

import { NgModule } from '@angular/core';
import { FormatTimePipe } from '@shared/pipes/format-time/format-time.pipe';
import { GenderPrefixPipe } from '@shared/pipes/gender-prefix/gender-prefix.pipe';
import { TokenExpireConfigService } from 'src/app/core/interceptors/token-expire-config/token-expire-config.service';
import { AnalyticsService } from './analytics/analytics.service';
import { AssetMapperService } from './asset/asset.mapper.service';
import { AssetService } from './asset/asset.service';
import { ChatDeskService } from './chat-desk/chat-desk.service';
import { ConfigService } from './config/config.service';
import { ContentService } from './content/content.service';
import { ContentfulService } from './contentful/contentful.service';
import { DateService } from './date/date.service';
import { ExtrasOverviewService } from './extras/extras-overview.service';
import { FlightService } from './flight/flight.service';
import { OptionOrderService } from './option-order/option-order.service';
import { OrderService } from './order/order.service';
import { PaxChangeService } from './passenger-change/passenger-change.service';
import { SearchFormService } from './search-form/search-form.service';
import { SessionStorageService } from './session-storage/session-storage.service';
import { StateService } from './state/state.service';
import { UrlService } from './url/url.service';
import { PdfService } from './pdf/pdf.service';
import { OrderDetailsPdfService } from './pdf/order-details-pdf.service';
import { FlightDetailsPdfService } from './pdf/flight-details-pdf.service';
import { BundledFarePdfService } from './pdf/bundled-fare-pdf.service';
import { ShoppingCartPdfService } from './pdf/shopping-cart-pdf.service';
import { PassengerDetailsPdfService } from './pdf/passenger-details-pdf.service';
import { MainbookerDetailsPdfService } from './pdf/mainbooker-details-pdf.service';

@NgModule({
  providers: [
    AnalyticsService,
    ConfigService,
    OptionOrderService,
    UrlService,
    DateService,
    FlightService,
    OrderService,
    ContentService,
    ContentfulService,
    AssetService,
    AssetMapperService,
    CurrencyPipe,
    GenderPrefixPipe,
    DatePipe,
    FormatTimePipe,
    SearchFormService,
    StateService,
    SessionStorageService,
    ExtrasOverviewService,
    ChatDeskService,
    PaxChangeService,
    TokenExpireConfigService,
    PdfService,
    OrderDetailsPdfService,
    FlightDetailsPdfService,
    BundledFarePdfService,
    ShoppingCartPdfService,
    PassengerDetailsPdfService,
    MainbookerDetailsPdfService,
  ],
})
export class ServicesModule {}
